import { render, staticRenderFns } from "./authContent.vue?vue&type=template&id=53da6fd2&scoped=true&"
import script from "./authContent.vue?vue&type=script&lang=js&"
export * from "./authContent.vue?vue&type=script&lang=js&"
import style0 from "./authContent.vue?vue&type=style&index=0&id=53da6fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da6fd2",
  null
  
)

export default component.exports